export const initGA = () => {
  const GA_ID = process.env.REACT_APP_GA_ID;
  if (!GA_ID) return;

  // aggiunge lo script gtag.js
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  // inizializza gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
};

// helper per tracciare pageview SPA
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', { page_path: path });
  }
};